import { render, staticRenderFns } from "./VehicleIssueTerms.vue?vue&type=template&id=bf075002&scoped=true&"
import script from "./VehicleIssueTerms.vue?vue&type=script&lang=js&"
export * from "./VehicleIssueTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf075002",
  null
  
)

export default component.exports